import * as dishes from '../constants/dishes';

export default {
  appConfig: {
    allowOrdering: false
  },
  order: {
    isModalOpen: false,
    //TODO: change to 'online' as payment gate will be ready
    paymentType: 'cash',
    entity: null
  },
  address: {
    streetAddress: '',
    latLng: null,
    deliveryInfo: '',
    phone: '',
    piAgreed: false
  },
  cart: {
    cartItems: [
      { dish: dishes.BORSZCZ, count: 1}
    ]
  },
  subscription: {
    isModalOpen: false,
    isShown: false,
    isSubscribed: false
  }
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js